import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'shared-list-item-neutral-button',
  standalone: true,
  templateUrl: './list-item-neutral-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex' },
})
export class ListItemNeutralButtonComponent {
  form = input<string | null>();
  type = input<'button' | 'submit' | 'reset'>('button');
  disabled = input<boolean>(false);
}
